// extracted by mini-css-extract-plugin
export default {"backdrop":"Style_backdrop__K7l-r","paymentPopup":"Style_paymentPopup__Fp+8L","withFooter":"Style_withFooter__MTe7x","content":"Style_content__GjGiH"};